import React, { SyntheticEvent, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const StupidElement = () => {
  return <div className="stupid-element"></div>;
};

export default StupidElement;
